export default __webpack_public_path__ + "static/media/ladefense.43de28ad.svg";